export default __webpack_public_path__ + "static/media/browser-wallet-light.ec45bc16.svg";